/**
 * @Description 申请提示
 */
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { FC, useMemo } from 'react';
import styles from '../index.module.less';
const ApplyHint: FC<any> = ({
  conflictInfo,
  isApplying, // 是否进入审批状态
  isMKD,
}) => {
  // 文案
  const content = useMemo(() => {
    // 是否不冲突
    const isNotConflict = !conflictInfo?.conflictRegionItemResponseList?.length;
    // 关闭区域保护
    if (!conflictInfo?.openFlag) {
      return <span className={styles.hintContent}>
        <ExclamationCircleOutlined className='mr-8 fs-18'
          style={{
            color: '#FF861D'
          }} />
        区域保护功能已关闭
      </span>;
    }
    return isNotConflict
      // 不冲突文案
      ? <span className={styles.hintContent}>
        <CheckCircleOutlined className='mr-8 fs-18' style={{
          color: '#52C41A'
        }} />
        符合要求，该点位属于{conflictInfo?.typeName || '-'}，周边{conflictInfo?.distanceType || '-'}{conflictInfo?.distanceStr || '-'}范围内没有其他门店/点位
      </span>
      // 冲突文案
      : <span className={styles.hintContent}>
        <ExclamationCircleOutlined className='mr-8 fs-18'
          style={{
            color: '#F23030'
          }} />
        {
          isMKD ? <>该区域已被保护，建议2天之后再次尝试申请或选择其他区域
          </> : <>该点位存在保护区冲突,该点位属于{conflictInfo?.typeName || '-'}，周边{conflictInfo?.distanceType || '-'}{conflictInfo?.distanceStr || '-'}范围内的门店/点位情况如下</>
        }
      </span>;
  }, [conflictInfo, isMKD]);

  // 样式
  const containerStyles = useMemo(() => {
    let style: any = {
      fontSize: '14px',
    };
    const commonStyle = {
      marginTop: '20px',
      marginBottom: '16px',
      paddingLeft: '14px',
      height: '48px',
      lineHeight: '48px',
      borderRadius: '4px',
    };
    // 是否冲突
    const isConflict = conflictInfo?.conflictRegionItemResponseList?.length;
    // isApplying 是否审批中

    // 关闭区域保护
    if (!conflictInfo?.openFlag) {
      return {
        ...style,
        color: '#FF861D',
        marginTop: '16px',
        marginBottom: '8px',
      };
    }

    if (!isConflict && !isApplying) {
      // 符合要求+发起审批中
      style = {
        ...style,
        ...commonStyle,
        color: '#47AD16',
        border: '1px solid #B7EB8F',
        background: '#F6FFED',
      };
    } else if (isConflict && !isApplying) {
      // 不符合要求-冲突+发起审批中
      style = {
        ...style,
        ...commonStyle,
        color: '#F23030',
        border: '1px solid #FFA39E',
        background: '#FFF1F0',
      };
    } else if (!isConflict && isApplying) {
      // 符合要求+审批详情
      style = {
        ...style,
        color: '#47AD16',
        marginTop: '16px',
        marginBottom: '8px',
      };
    } else {
      // 不符合要求-冲突+审批详情
      style = {
        ...style,
        color: '#F23030',
        marginTop: '16px',
        marginBottom: '8px',
      };
    }

    return style;
  }, [conflictInfo, isApplying]);

  return <div style={containerStyles}>
    {content}
  </div>;
};
export default ApplyHint;
